export default __webpack_public_path__ + "static/media/planning.e01c867f.jpg";